<template>
  <div>
    <!-- 로고 / 타이틀 / QR-->
    <div class="flex" style="justify-content: space-between;">
      <div style="width: 30%;">
        <img src="@/assets/images/동국제강_로그인.svg" alt="close" />
      </div>
      <div class="titleText">일 안전작업허가 (돌발보수)</div>
      <div class="flex justify-end" style="width: 30%;">
        <div style="margin-right: 20px;font-size: 15px;">[승인/확인용 QR]</div>
        <div style="width: 106px; height: 106px; padding: 2px; border: 1px solid #333;" class="flex justify-center items-center">
          <img :src="`${config.BASE_API_URL}/api/v1/qr/generate?code=${currentUrl}&size=200&padding=1`" width="100" alt="QR Code" />
        </div>
      </div>
    </div>

    <!-- 문서 정보 -->
    <div style="margin-top: 34px;" class="flex flex-between document-info">
      <div class="w-full flex-1">
        <div><span class="subtitle">■ 일 안전작업허가번호 : </span><span class="normal">{{ form.작업정보.허가번호 }}</span></div>
        <div><span class="subtitle">■ 허가 신청자 : </span><span class="normal">{{ form.stdInfo.writer_name }}</span></div>
        <div><span class="subtitle">■ 허가신청기간 : </span><span class="normal">{{ form.작업정보.허가신청기간 || '-' }}</span></div>
        <div><span class="subtitle">■ 연장신청기간 : </span><span class="normal">{{ form.작업정보.연장신청기간 }} {{ [form.작업정보.연장시간.시작, form.작업정보.연장시간.종료].join(' ~ ')}}</span></div>
        <div><span class="subtitle">■ 작업완료시간 : </span><span class="normal">{{ form.작업정보.작업완료날짜 }} {{ form.작업정보.작업완료시간 }}</span></div>
        <div><span class="subtitle blue">■ 작업 내용 : </span><span class="normal">{{ form.작업정보.작업내용 }}</span></div>
        <div><span class="subtitle blue">■ 업체 안전전담자 : </span><span class="normal">{{ form.안전관계자.동국제강.이름 }} {{ form.작업정보.작업완료시간 }}</span></div>
      </div>
      <div class="w-full flex-1">
        <div><span class="subtitle">&nbsp;</span><span class="normal"></span></div>
        <div><span class="subtitle">■ 허가승인 : </span><span class="normal">{{ form.작업정보.허가승인일시 }} {{ form.작업정보.허가시각 }}</span></div>
        <div><span class="subtitle">■ 허가승인자 : </span><span class="normal">-</span></div>
        <div><span class="subtitle">■ 연장승인자 : </span><span class="normal">-</span></div>
        <div><span class="subtitle">■ 확인자(안전환경팀, 필요시) : </span><span class="normal relative">{{ form.안전관계자.확인자 || '-' }} (인)
          <div v-if="form.안전관계자.확인자서명.sign" class="absolute" style="right: 20px; top: 0; transform: translate(100%, -30%)"><img :src="form.안전관계자.확인자서명.sign" width="100" alt="Signature" class="signatureImg" /></div>
        </span></div>
        <div><span class="subtitle blue">■ 작업 장소 : </span><span class="normal">{{ form.작업정보.작업구역.label }} {{ form.작업정보.작업존.label }}</span></div>
        <div><span class="subtitle blue">■ 작업 인원수 : </span><span class="normal">{{ (form.작업자내역 || []).length}}</span></div>
      </div>
    </div>
    <div class="document-info flex items-center">
      <span class="subtitle blue inline-flex">■ 작업유형 : </span>
      <span class="normal" style="display: inline-flex">
        <span v-for="item of inspectionTitle" :key="item" class="flex items-center mx-2">
          <span class="flex mr-1">
            <PrintCheckbox :value="(form.inspectChecked || []).includes(item)" color style="width: fit-content" class="mx-auto" />
          </span>
          <span class="blue">{{ item }}</span>
        </span>
      </span>
    </div>

    <div style="margin-top: 18px;" class="normal">※ 최초허가기간(최대 8시간) 종료후 최대 4시간까지 연장허가 가능</div>

    <!--체크리스트-->
    <div class="checkListContainer">
      <vs-row>
        <!--일반작업-->
        <template v-for="(title, titleIdx) of checkListTitles">
          <vs-col v-if="(form.inspectChecked || []).includes(title)" class="w-6/12" :key="title">
            <table>
              <thead>
              <tr>
                <th>◇ {{ title }}</th>
                <th style="width: 70px;">신청자</th>
                <th style="width: 70px;">허가자</th>
                <th style="width: 70px;">연장허가</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item of inspectTable(titleIdx + 1)" :key="item.content">
                <td>
                  {{ item.content }}
                  <span v-if="getCheckValue(`inspectList_${titleIdx + 1}`, item.content, '위치')" style="color: blue;">
                    &nbsp;(위치 : {{getCheckValue(`inspectList_${titleIdx + 1}`, item.content, '위치')}})
                  </span>
                  <span v-else-if="getCheckValue(`inspectList_${titleIdx + 1}`, item.content, '성명')" style="color: blue;">
                    &nbsp;(성명 : {{getCheckValue(`inspectList_${titleIdx + 1}`, item.content, '성명')}})
                  </span>
                </td>
                <td><PrintCheckbox :value="isChecked(`inspectList_${titleIdx + 1}`, item.content, '신청자')" style="width: fit-content" class="mx-auto" /></td>
                <td><PrintCheckbox :value="isChecked(`inspectList_${titleIdx + 1}`, item.content, '허가자')" style="width: fit-content" class="mx-auto" /></td>
                <td><PrintCheckbox :value="isChecked(`inspectList_${titleIdx + 1}`, item.content, '연장하가')" style="width: fit-content" class="mx-auto" /></td>
              </tr>
              </tbody>
            </table>
          </vs-col>
        </template>
      </vs-row>
    </div>

    <!--작업자내역-->
    <div class="userListContainer" style="margin-top: 20px;">
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
        <tr>
          <th>No.</th>
          <th>성명</th>
          <th>연락처</th>
          <th>내국인/외국인</th>
          <th>건강정보(수축/이완)</th>
          <th>작업가능 여부</th>
          <th>교육만료 일자</th>
          <th>입문시간</th>
          <th>출문시간</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, itemIdx) of form.작업자내역" :key="item.성명">
          <td>{{ itemIdx + 1 }}</td>
          <td>{{ item.userName }}</td>
          <td>{{ item.직위직책 }}</td>
          <td>{{ item.연락처 }}</td>
          <td>{{ item.내국인외국인 }}</td>
          <td>{{ item.건강정보_수축 }} / {{ item.건강정보_이완 }}</td>
          <td>{{ item.교육만료일자 }}</td>
          <td>{{ item.입문날짜 }} {{ item.입문시간 }}</td>
          <td>{{ item.출문날짜 }} {{ item.출문시간 }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import VueQRCodeComponent from "vue-qrcode-component";
import {inspectTable_1, inspectTable_2, inspectTable_3, inspectTable_4, inspectTable_5, inspectTable_6, inspectTable_7, inspectTable_8} from "@/views/boards/single-page/930/inspectData";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import config from "../../../../../public/config";

export default {
  name: "Print930",
  components: {PrintCheckbox, VueQRCodeComponent},
  props: {
    form: Object,
    inspectionTitle: Array,
  },
  computed: {
    config() {
      return config
    },
    currentUrl() {
      // 현재 페이지의 URL을 반환하되, ? 이후의 쿼리스트링은 제외한다.
      return window.location.href.split("?")[0];
    },
    checkListTitles() {
      return ['일반작업', '화기작업', '고소작업', '중장비 관련 작업', '밀폐(제한)공간 작업', '정전(전기차단)작업', '굴착작업', '방사선 관련 작업'];
    }
  },
  methods: {
    inspectTable(num) {
      switch (num) {
      case 1:
        return inspectTable_1;
      case 2:
        return inspectTable_2;
      case 3:
        return inspectTable_3;
      case 4:
        return inspectTable_4;
      case 5:
        return inspectTable_5;
      case 6:
        return inspectTable_6;
      case 7:
        return inspectTable_7;
      case 8:
        return inspectTable_8;
      default:
        return [];
      }
    },
    isChecked(inspectionKey, content, value) {
      return this.form[inspectionKey].find((f) => f.content === content).isChecked === value;
    },
    getCheckValue(inspectionKey, content, key) {
      return this.form[inspectionKey].find((f) => f.content === content)[key];
    }
  }
};
</script>
<style lang="scss" scoped>
.titleText {
  font-size: 32px;
  font-weight: 700;
}

.document-info {
  .subtitle {
    font-size: 14px;
    font-weight: 700;
    line-height: 26px;
  }
  .normal {
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
  }
  .blue {
    color: #0000ff;
  }
}

.checkListContainer {
  table {
    width: 100%;
    border-collapse: collapse;

    th, td {
      border: 1px solid #757575;
      padding: 4px 7px;
      text-align: center;
      font-size: 14px;
      color: #3c3c3c;
    }
    th {
      background-color: #ececec
    }
    tr {
      th:first-child, td:first-child {
        text-align: left;
      }
      th:first-child {

      }

    }
  }
}

.userListContainer {
  table {
    width: 100%;
    border-collapse: collapse;

    th, td {
      border: 1px solid #757575;
      padding: 4px 7px;
      text-align: center;
      font-size: 14px;
      color: #3c3c3c;
    }
    th {
      background-color: #ececec
    }
  }
}
</style>
